import { render } from "./ListeCommande.vue?vue&type=template&id=3fa0241b&ts=true"
import script from "./ListeCommande.vue?vue&type=script&lang=ts"
export * from "./ListeCommande.vue?vue&type=script&lang=ts"

import "./ListeCommande.vue?vue&type=style&index=0&id=3fa0241b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__